import { unwrap } from "@nexxt/api-client";
import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { auth } from "../../api";

/** The signed-in user with roles and permissions (identity `getMe`): the menus and actions follow it. */
export const meQuery = queryOptions({
  queryKey: ["me"],
  queryFn: () => unwrap(auth.me.$get()),
  staleTime: 5 * 60_000,
});

export function useMe() {
  return useSuspenseQuery(meQuery).data;
}

/** Hides what the user cannot do; the gateway and crm check again (ADR-014). */
export function useCan(permission: string): boolean {
  return useMe().permissions.includes(permission);
}

/** The session closes here, then the Logto one at `logoutUrl` (ADR-032, point 7). */
export async function signOut(): Promise<void> {
  const { logoutUrl } = await unwrap(auth.logout.$post());
  location.assign(logoutUrl);
}
